import React from 'react';
import { Link } from 'react-router-dom';
import BotMessage from '../BotMessage/BotMessage';
import IndividualConversation from '../../../types/IndividualConversation';
import MessageHistory from '../../../types/MessageHistory';
import RatingContainer from '../RatingContainer/RatingContainer';
import ResponseCards from '../ResponseCards/ResponseCards';
import formatDate from '../../../utils/formatDate';
import { MessageReviewUpdate } from '../ChatMessageContainer/ChatMessageContainer';

interface BotMessageProps {
  message: MessageHistory;
  conversation: IndividualConversation;
  setError: React.Dispatch<React.SetStateAction<string>>;
  showTranslated: boolean;
  hideReviews?: boolean;
  onMessageReviewUpdate?: (
    messageId: number,
    update: MessageReviewUpdate
  ) => void;
}

function BotMessagesContainer({
  message,
  conversation,
  setError,
  showTranslated,
  hideReviews = false,
  onMessageReviewUpdate
}: BotMessageProps): React.ReactElement {
  return (
    <>
      {message.chatMessageResponse.chatMessageResponseBlocks.map(
        (block, blockIndex) => (
          <BotMessage
            key={block.id}
            block={block}
            blockIndex={blockIndex}
            showTranslated={showTranslated}
          />
        )
      )}
      <ResponseCards
        cards={message.chatMessageResponse.chatMessageResponseCards}
      />
      <div className='flex justify-start'>
        <div className='w-[70%]'>
          <p className='text-text-secondary mt-1.5 text-xs'>
            {formatDate(message.chatMessage.messageTime)}
            {message.chatMessageResponse.chatMessageResponseBlocks[0]
              ?.category && (
              <>
                {' '}
                | Topic:{' '}
                {
                  message.chatMessageResponse.chatMessageResponseBlocks[0]
                    .category
                }
              </>
            )}
            {message.chatMessage.health !== undefined &&
              message.chatMessage.health !== 0 && (
                <> | Score: {message.chatMessage.health ?? '-'}</>
              )}
          </p>
          {message.chatMessageResponse.matchedIntentName && (
            <p className='text-text-secondary mt-0.5 text-xs'>
              Matched question:{' '}
              {message.chatMessageResponse.matchedIntentId ? (
                <Link
                  to={`/bot-builder/${conversation.conversationSummary.chatbotId}/${message.chatMessageResponse.matchedIntentId}`}
                  className='hover:underline text-brand-light font-semibold'
                  target='_blank'
                  rel='noopener'
                >
                  {message.chatMessageResponse.matchedIntentName}
                </Link>
              ) : (
                message.chatMessageResponse.matchedIntentName
              )}
            </p>
          )}
          {message.chatMessage.matchedSlots &&
            message.chatMessage.matchedSlots.length > 0 && (
              <p className='text-text-secondary mt-0.5 text-xs'>
                {message.chatMessage.matchedSlots
                  .map(
                    (slot) =>
                      `Variable: ${slot.name} = ${slot.value ?? '(empty)'}`
                  )
                  .join(' | ')}
              </p>
            )}
          {!hideReviews && (
            <RatingContainer
              reviewerRating={message.chatMessage.dashboardRating}
              userRating={message.chatMessage.userRating}
              messageId={message.messageId}
              chatbotId={conversation.conversationSummary.chatbotId}
              reviewTag={message.chatMessage.reviewTag}
              reviewComment={message.chatMessage.reviewComment}
              issue={message.chatMessage.issue}
              setError={setError}
              onReviewUpdate={
                onMessageReviewUpdate
                  ? (update): void =>
                      onMessageReviewUpdate(message.messageId, update)
                  : undefined
              }
            />
          )}
        </div>
      </div>
    </>
  );
}

export default BotMessagesContainer;
